import React, { useState } from 'react'
import PlaygroundApp from '../../components/lexicalEditor/lexical-playground/src/App'
import { Button } from '@mui/material'

function SimpleEditor() {

  const [editorState, setEditorState] = useState('')
  const [htmlState, setHtmlState] = useState('')


  const handleSave = () => {
    const state = {
      editorState,
      htmlState
    }
    const jsonString = JSON.stringify(state)
    window.ReactNativeWebView.postMessage(jsonString)
  }

  const handleCancel = () => {
    const state = {
      cancel : true
    }
    const jsonString = JSON.stringify(state)
    window.ReactNativeWebView.postMessage(jsonString)
  }

  return (
    <>
      <PlaygroundApp
        // html = "mm"
        editorState={{}}
        onChangeEditorState={setEditorState}
        onChangeHtml={setHtmlState}
        isMobile={true}
        enableVoice={false}
        isSimpleEditor={true}
      />

      <div style={{
        display: 'flex',
        // alignSelf: 'center',
        alignItems: 'center',
        // alignContent: 'center',
        justifyContent: 'space-around',
      }}>
        <Button onClick={handleCancel} variant="outlined" color="secondary"> Cancel </Button>
        <Button onClick={handleSave} variant="contained" color="primary"> Save </Button>
      </div>

    </>
  )
}

export default SimpleEditor